module.exports = __webpack_public_path__ + "img/guide-arrow.e1612b36.png";